import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../components/UserContext";
import DataLoading from "../components/DataLoading";
import axiosInstance from "../helper/axios";
import Trans from "../helper/Trans";
import {useNavigate } from "react-router-dom";
import DocumentItem from "../components/DocumentItem";
import { notify } from "../helper/Helper";
const attApi = axiosInstance;

function Documents(props) {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [moreData, setMoreData] = useState([]);
  const [colNames, setColNames] = useState({});
  const [images, setImages] = useState({});
  const [errors, setErrors] = useState({});
  const [allowSave, setAllowSave] = useState(false);
  const navigate = useNavigate();

  const {
    setTitle,
    setOperation,
    setPLink,
    siteInfo,
    applicantStatus,
    getFillStatus,
  } = useContext(UserContext);

  useEffect(() => {
    setTitle("Documents");
    setOperation("Add Documents");
    setPLink("");
  }, [setTitle, setOperation, setPLink]);

  useEffect(() => {
    if (applicantStatus) {
      if (applicantStatus.docInfo) {
        setOperation("Update Documents");
      }
    }
  }, [applicantStatus, setOperation]);

  useEffect(() => {
    if (siteInfo !== null) {
      setLoading(true);
      attApi.get("get-document-needed").then((response) => {
        if (response.data.success === false) {
          navigate("/profile");
          setLoading(false);
          return;
        }
        setMoreData(response.data.steps);
        setColNames(response.data.meta);
        setAllowSave(response.data.allowSave);

        attApi.get("get-document-info").then((response2) => {
          let OldData = response2.data.data;
          let mndata = [];
          let imgData = {};

          response.data.steps.forEach((md, index) => {
            if (OldData[md.step_did]) {
              let od = OldData[md.step_did];
              imgData[md.step_did] =
                od.path === ""
                  ? ""
                  : process.env.REACT_APP_BACKEND_URL2 + od.path;
              mndata.push({
                ...md,
                detail: od.detail,
                path: od.path,
              });
            } else {
              mndata.push(md);
            }
          });
          setMoreData(mndata);
          setImages(imgData);
          setLoading(false);
        });
      });
    }
  }, [siteInfo, navigate]);

  const onImageChange = (e, prefno) => {
    const { name } = e.target;
    const nextData = [];

    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      const { name } = e.target;

      moreData.forEach((md, index) => {
        if (md.step_did === prefno) {
          nextData.push({ ...md, [name]: img });
        } else {
          nextData.push(md);
        }
      });
      let nimg = (window.URL || window.webkitURL).createObjectURL(img);
      setImages({ ...images, [prefno]: nimg });
      setMoreData(nextData);
    }
    const newErrors = {};
    Object.keys(errors).forEach(function (key2) {
      let oldNode = errors[key2];
      /* eslint-disable eqeqeq */
      if (key2 == prefno) {
        /* eslint-enable eqeqeq */
        newErrors[key2] = { ...oldNode, [name]: "" };
      } else {
        newErrors[key2] = oldNode;
      }
    });
    setErrors(newErrors);
  };

  const handleInputChange = (e, prefno) => {
    const { name, value } = e.target;
    const nextData = [];

    moreData.forEach((md, index) => {
      if (md.step_did === prefno) {
        nextData.push({ ...md, [name]: value });
      } else {
        nextData.push(md);
      }
    });

    setMoreData(nextData);
    const newErrors = {};
    Object.keys(errors).forEach(function (key2) {
      let oldNode = errors[key2];
      /* eslint-disable eqeqeq */
      if (key2 == prefno) {
        /* eslint-enable eqeqeq */
        newErrors[key2] = { ...oldNode, [name]: "" };
      } else {
        newErrors[key2] = oldNode;
      }
    });
    setErrors(newErrors);
  };

  function saveMoreInfo() {
    const newErrors = {};
    var formData2 = new FormData();
    var stepIds = [];
    var errorCount = 0;
    moreData.forEach((dataItem) => {
      stepIds.push(dataItem.step_did);
      var stepId = dataItem.step_did;

      let oldErrorNode = errors[stepId] ? errors[stepId] : {};
      if (dataItem.step_did === stepId) {
        let reqCols2 = [];

        reqCols2.push("path");

        if (!newErrors[dataItem.step_did]) {
          newErrors[dataItem.step_did] = {};
        }
        reqCols2.forEach((key) => {
          let colName = colNames[key] ? colNames[key] : "Data";
          if (!dataItem[key]) {
            newErrors[dataItem.step_did][key] = colName + " cannot be blank.";
            errorCount++;
          }
        });

        formData2.append(
          `ApplicantDocument[${stepId}][path]`,
          dataItem["path"]
        );
        formData2.append(
          `ApplicantDocument[${stepId}][detail]`,
          dataItem["detail"]
        );
      } else {
        newErrors[dataItem.step_did] = oldErrorNode;
      }

      formData2.append("stepIds", stepIds);
    });
    if (newErrors && errorCount === 0) {
      attApi
        .post("/add-update-document-info", formData2, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === false) {
              notify(res.data.message, "error");
              setErrors(res.data.errors);
            } else {
              notify(res.data.message, "success");
              getFillStatus();
            }
          } else {
            notify(res.data.message, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          notify("Error Validating the Form", "error");
        })
        .finally(() => {
          setLoading2(false);
        });
    } else {
      setErrors(newErrors);
    }
  }

  function moveNext() {
    let to = "/choose";
    navigate(to);
  }

  function saveData(e) {
    e.preventDefault();
    setLoading2(true);
    if (moreData.length > 0) {
      saveMoreInfo();
    }
    setLoading2(false);
  }

  return (
    <>
      {loading ? (
        <DataLoading />
      ) : (
        <div className="card mb-2">
          <div className="card-body">
            {moreData.map((dataItem) => (
              <div className="mb-1" key={dataItem.step_did}>
                <DocumentItem
                  key={dataItem.step_did}
                  colNames={colNames}
                  data={dataItem}
                  handleInputChange={handleInputChange}
                  onImageChange={onImageChange}
                  errors={errors}
                  loading2={loading2}
                  img={images[dataItem.step_did]}
                  allowSave={allowSave}
                />
              </div>
            ))}

            {loading2 ? (
              <DataLoading />
            ) : (
              <>
                {moreData.length > 0 ? (
                  <div className="form-group mt-3">
                    {allowSave ? (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        name="save-button"
                        onClick={saveData}
                      >
                        {Trans("Save")}
                      </button>
                    ) : (
                      <></>
                    )}
                    {applicantStatus && applicantStatus.documents === true  && applicantStatus.application_submitted === false? (
                      <button
                        className="btn btn-outline-secondary m-2"
                        onClick={moveNext}
                      >
                        {Trans("Next")}
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Documents;
